const ICON_GLOBE = ({ color = "#000", strokeWidth = 3, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <circle
      cx={5}
      cy={5}
      r={4.65}
      style={{
        fill: "none",
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        stroke: color,
      }}
    />
    <path
      d="M.35 5h9.3"
      style={{
        fill: "none",
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        stroke: color,
      }}
    />
    <ellipse
      cx={5}
      cy={5}
      rx={2.109}
      ry={4.65}
      style={{
        fill: "none",
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        stroke: color,
      }}
    />
    <path
      d="M5.001.35a4.65 4.65 0 0 0-3.893 2.11 8.071 4.65 0 0 0 3.893.579 8.071 4.65 0 0 0 3.89-.582A4.65 4.65 0 0 0 5.002.35zM5.001 9.65a4.65 4.65 0 0 1-3.893-2.11 8.071 4.65 0 0 1 3.893-.578 8.071 4.65 0 0 1 3.89.581 4.65 4.65 0 0 1-3.89 2.107z"
      style={{
        fill: "none",
        paintOrder: "markers fill stroke",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 0.7,
        stroke: color,
      }}
    />
  </svg>
);

export default ICON_GLOBE;
